import React from 'react';
import { useSelector } from 'react-redux';
import { Container, Col, Row } from '@yme/atoms/grid';
import { HeroSectionContentPage } from '@yme/organisms/hero-section';
import { getRTL } from '@yme/selectors/common';
import { IndentWrapper } from '../Separator';
import { DescriptionContainer, DescriptionStyled } from './styled';
export function MaintenanceHeroSection(props) {
    const { title, description, backgroundImage, isRemoveBottomIndent } = props;
    const isRightToLeft = useSelector(getRTL);
    if (!title || !backgroundImage) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(HeroSectionContentPage, { title: title, backgroundImage: backgroundImage, isRightToLeft: isRightToLeft }),
        React.createElement(DescriptionContainer, null,
            React.createElement(Container, null,
                React.createElement(Row, { alignItems: "center", justifyContent: "center" },
                    React.createElement(Col, { lg: 6, md: 8 },
                        React.createElement(DescriptionStyled, null, description)))))));
}
MaintenanceHeroSection.displayName = 'MaintenanceHeroSection_AEMComponent';
